import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Modal, Button, Form, Card, Spinner } from 'react-bootstrap';
import cyberSecurityData from '../../../apis/cyberSecurityData';
import history from '../../../history';
import { updateProfile } from '../../../actions/userActions';
import { updateDefaultPaymentMethods, updateSubscriptionData } from '../../../actions/SubDataActions';
//stripe
// import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
//comps
// import AddCardForm from './Subscription/AddCardForm-BAK';
//json data
import pricesValues from '../../../configs/pricesValues.json';

const UpgradeModal = ({ showUpgradeModal, setShowUpgradeModal, defaultYearly }) => {
  //redux
  const accessToken = useSelector(state => state.accessToken);
  const paymentMethods = useSelector(state => state.subData.paymentMethods ? state.subData.paymentMethods : []);
  const defaultPaymentMethod = useSelector(state => state.subData.defaultPaymentMethod ? state.subData.defaultPaymentMethod : '');
  const currentUser = useSelector(state => state.currentUser);
  const darkMode = useSelector(state => state.darkMode);
  const dispatch = useDispatch();
  //local state
  const [yearly, setyearly] = useState(true);
  const [useNew, setUseNew] = useState(false);
  const [error, setError] = useState('');
  const [responseError, setResponseError] = useState('');

  //Loading check
  const [loading, setLoading] = useState(false);
  //selcted Payment method
  const [paymentMethod, setPaymentMethod] = useState(defaultPaymentMethod);

  useEffect(() => {
    if (paymentMethods.length === 0) setUseNew(true);
  }, []);

  useEffect(() => {
    if (defaultYearly !== undefined) setyearly(defaultYearly);
  }, [defaultYearly]);

  //stripe
  // const stripe = useStripe();
  // const elements = useElements();

  const handleClose = () => {
    setError('');
    setResponseError('');
    setShowUpgradeModal(false);
    setLoading(false);
    setUseNew(false);
  };

  const onToogleChange = (e) => {
    setyearly(e.target.checked);
  };

  // const onSubmitClick = async (paymentMethodId) => {
  //   const method = paymentMethodId ? paymentMethodId : paymentMethod;

  //   const data = {
  //     yearly
  //   };

  //   try {
  //     setLoading(true);
  //     //to create the subscription (status will be incomplete waiting for payment confirmation), the response will be having client_secrete and subscriptionId
  //     const response = await cyberSecurityData.post('/upgrade-subscription', data, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken
  //       }
  //     });
  //     console.log(response.data);

  //     if (response.data && response.data.clientSecret) {
  //       //confirm the payment, and in the server the subscription will be completed using hooks
  //       const confirmResponse = await stripe.confirmCardPayment(response.data.clientSecret, {
  //         payment_method: method
  //       });

  //       console.log({ confirmResponse });

  //       if (confirmResponse.error) {
  //         const { payment_intent, payment_method } = confirmResponse.error;
  //         //detach the payment method from the user
  //         await cyberSecurityData.post('/cancel-payment', { paymentIntentId: payment_intent.id, paymentMethodId: payment_method.id }, {
  //           headers: {
  //             Authorization: 'Bearer ' + accessToken
  //           }
  //         });

  //         setLoading(false);
  //         return setResponseError(confirmResponse.error.message);
  //       }

  //       if (confirmResponse.paymentIntent?.status === 'succeeded') {
  //         //update the user data
  //         const updateResponse = await cyberSecurityData.post('/upgrade-success', { paymentMethod: confirmResponse.paymentIntent.payment_method, yearly }, {
  //           headers: {
  //             Authorization: 'Bearer ' + accessToken
  //           }
  //         });

  //         if (updateResponse.data.user) dispatch(updateProfile(updateResponse.data.user));
  //         if (updateResponse.data.subscription) dispatch(updateSubscriptionData(updateResponse.data.subscription));
  //         if (updateResponse.data.defaultPaymentMethod) dispatch(updateDefaultPaymentMethods(updateResponse.data.defaultPaymentMethod));

  //         handleClose();
  //       }
  //     }

  //     setResponseError('');
  //     setLoading(false);

  //   } catch (error) {
  //     setResponseError('Upgrade failed please try again');
  //   }
  // };

  const renderExpirationDate = (exp_month, exp_year) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[exp_month - 1];
    const year = exp_year;
    return `${month} ${year}`;
  };

  const renderCardLogo = (brand) => {
    if (brand === 'visa') return require('../../../images/visa-logo-png-transparent.png');
    if (brand === 'mastercard') return require('../../../images/paymentCards/materCard.png');
    if (brand === 'amex') return require('../../../images/paymentCards/amex.png');
    if (brand === 'discover') return require('../../../images/paymentCards/discover-logo.png');
    if (brand === 'diners') return require('../../../images/paymentCards/diners-club.png');
    return require('../../../images/paymentCards/credit-card.png');
  };

  return (
    <Modal show={showUpgradeModal} onHide={handleClose} centered size="lg" className="upgrade-modal">
      <Modal.Header closeButton className="border-bottom">
        <div className="text-center py-3 px-5">
          <h3 className="title-section">Upgrade to <strong>Proffesional</strong> Subscription</h3>
          <a href="/pricing" target="_blank" className="d-block text-blue text-lg text-underline pb-3 pointer">Pricing Plans Comparison</a>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row className="pt-4">
          <Col md={5} className="border-right pr-md-4">
            <div className="d-flex align-items-center justify-content-center billing-cycle">
              <span> Monthly</span>
              <div className="onoffswitch mx-3">
                <input type="checkbox" name="onoffswitch" className="onoffswitch-checkbox" id="myonoffswitch" tabIndex="0" checked={yearly} onChange={onToogleChange} />
                <label className="onoffswitch-label" htmlFor="myonoffswitch">
                  <span className="onoffswitch-inner"></span>
                  <span className="onoffswitch-switch"></span>
                </label>
              </div>
              <span>Annual</span>
            </div>

            <Card className="mt-4">
              <Card.Body>
                <div className="text-center">
                  <div className="text-center">
                    {yearly && <div className="pricing-table__title">Annual</div>}
                    {!yearly && <div className="pricing-table__title">Monthly</div>}

                    {yearly && <span className="pricing-table__price pricing-table__price--annual my-2">
                      <span className="d-inline-block position-relative">
                        <span className="price-discount">{pricesValues.yearlyDiscount} Off</span>
                        <span className="old-price">${pricesValues.listPrice}</span></span>
                      <span className="d-inline-flex align-items-baseline ml-2">
                        <sup>$</sup>
                        <span>{pricesValues.yearlyPerMonth}</span>
                        <sup>.{pricesValues.yearlyPerMonthFraction}</sup><span className="price-cycle">/  Month</span></span></span>}
                    {!yearly && <span className="pricing-table__price pricing-table__price--annual my-2"><span className="d-inline-block position-relative"><span className="price-discount">{pricesValues.monthlyDiscount} Off</span>
                      <span className="old-price">${pricesValues.listPrice}</span></span>
                      <span className="d-inline-flex align-items-baseline ml-2"> <sup>$</sup>{pricesValues.monthly} <span className="price-cycle">/  Month</span></span></span>}
                  </div>
                  {yearly && <span className="text-light-grey-md">${pricesValues.yearlyTotal} billed annually</span>}

                </div>
              </Card.Body>
            </Card>

            <Card className="my-4">
              <Card.Header className="d-flex justify-content-between"><h3 className="mb-0">Order Summary</h3></Card.Header>
              <Card.Body>
                <div className="d-flex justify-content-between mb-3">
                  {yearly && <span>Professional (Annual)</span>}
                  {!yearly && <span>Professional (Monthly)</span>}

                  {yearly && <span>${pricesValues.yearlyTotal}</span>}
                  {!yearly && <span>${pricesValues.monthly}</span>}

                </div>

                <div className="d-flex justify-content-between">
                  <strong>Total Due Today</strong>
                  {yearly && <span>${pricesValues.yearlyTotal}</span>}
                  {!yearly && <span>${pricesValues.monthly}</span>}
                </div>
              </Card.Body>
            </Card>

          </Col>

          {!useNew && paymentMethods.length > 0 && <Col md={7} className="pl-md-4">
            <strong className="d-block pb-3">Choose the payment method to use</strong>
            <Card className="d-flex flex-wrap">
              <Card.Body>
                {paymentMethods?.length > 0 && paymentMethods.map(method => {
                  const { brand, last4, billing_details, exp_month, exp_year, defaultCard, id } = method;
                  return (
                    <div className="mr-5 mb-4 pointer profile-page" key={method.id} onClick={() => setPaymentMethod(id)}>
                      <div className={`payment-card ${id === paymentMethod ? 'border' : ''}`} >
                        <div className="payment-card__logo d-flex align-items-center">
                          <img src={renderCardLogo(brand)} alt="#" className="img-fluid" />
                        </div>
                        <div className="payment-card__body">
                          <div className="payment-card__number">**** **** **** {last4}</div>
                          <div className="payment-card__name">{billing_details.name}</div>
                          <div className="payment-card__exp">Expires on: {renderExpirationDate(exp_month, exp_year)}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <Button size="sm" onClick={() => setUseNew(true)}>Add new card</Button>
              </Card.Body>
            </Card>
            <div className="d-flex mt-4">
              <Button className="mr-2" variant="outline-secondary" onClick={handleClose}>Cancel</Button>
              {/* <Button onClick={() => onSubmitClick()} disabled={loading} style={{ minWidth: 90 }}>
                <div>
                  {loading ? <Spinner className="mx-auto" animation="border" size="sm" /> : <span>Upgrade</span>}
                </div>
              </Button> */}
            </div>
          </Col>}

          {(useNew || paymentMethods.length === 0) && <Col md={7} className="pl-md-4">
            {/* <AddCardForm cancelCallback={handleClose} cardAddedCallback={onSubmitClick} submitLabel="Upgrade" /> */}
          </Col>}

        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default UpgradeModal;
